<script setup lang="ts">
import { ref } from "vue";
import { useTranslation } from "i18next-vue";
import { useGetFieldPartTemplates } from "@/stores/queries/field-observations.query";
import FieldPartTemplateItem from "@/components/field-part-templates/FieldPartTemplateItem.vue";
import DRDisplayList from "@/components/UI/items/DRDisplayList.vue";
import OrganizationPageLayout from "@/components/organization/OrganizationPageLayout.vue";
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";
import DRBtn from "@/components/UI/DRBtn.vue";
import CreateTemplateDrawer from "@/components/field-part-templates/CreateTemplateDrawer.vue";

const { t } = useTranslation();

const { data: templates, isLoading } = useGetFieldPartTemplates();

const showCreateDrawer = ref(false);
</script>

<template>
  <OrganizationPageLayout
    :title="t('dashboard:navigation.structure-parts')"
    :description="t('dashboard:navigation.structure-parts-description')"
  >
    <template #actions>
      <DRBtn
        variant="primary"
        icon="bi-plus-lg"
        :label="t('dashboard:fieldObservations.partTemplates.create.button')"
        @click="showCreateDrawer = true"
      />
    </template>

    <DRDisplayList
      :data="templates"
      key-index="id"
      :loading="isLoading"
      display="list"
    >
      <template #item="{ item, display }">
        <FieldPartTemplateItem :template="item" :display="display" />
      </template>
      <template #empty>
        <div class="py-5 text-center">
          <PhosphorIcon
            name="tree-structure"
            :size="48"
            class="text-muted mb-3"
          />
          <p class="fs-5 text-muted mb-2">
            {{ t("dashboard:fieldObservations.partTemplates.empty") }}
          </p>
          <p class="small text-muted">
            {{
              t("dashboard:fieldObservations.partTemplates.emptyDescription")
            }}
          </p>
        </div>
      </template>
    </DRDisplayList>

    <CreateTemplateDrawer v-model="showCreateDrawer" />
  </OrganizationPageLayout>
</template>
